import { isDefined } from "@clipboard-health/util-ts";
import { Box, Stack } from "@mui/material";
import { WorkerAvatar } from "@src/appV2/redesign/components/WorkerAvatar";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { formatDistanceToNow } from "date-fns";

interface WorkplaceReviewCommentAuthorInfoProps {
  workerName: string;
  profilePictureUrl?: string;
  isLoadingProfilePicture?: boolean;
  createdAt: Date;
  shiftWorkerQualification?: string;
  useDelayedReviewLayout?: boolean;
}

export function WorkplaceReviewCommentAuthorInfo(props: WorkplaceReviewCommentAuthorInfoProps) {
  const {
    workerName,
    profilePictureUrl,
    isLoadingProfilePicture,
    createdAt,
    shiftWorkerQualification,
    useDelayedReviewLayout,
  } = props;

  if (useDelayedReviewLayout) {
    return (
      <Stack direction="row" spacing={3} alignItems="flex-start" sx={{ width: "100%" }}>
        <WorkerAvatar
          profilePictureUrl={profilePictureUrl}
          isLoading={isLoadingProfilePicture}
          size="small"
        />

        <Stack direction="row" justifyContent="space-between" sx={{ flex: 1 }}>
          <Box>
            <Text semibold variant="body2">
              {workerName}
            </Text>
            {isDefined(shiftWorkerQualification) && (
              <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
                {shiftWorkerQualification}
              </Text>
            )}
          </Box>

          <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
            {formatDistanceToNow(createdAt)} ago
          </Text>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={3}>
      <WorkerAvatar
        profilePictureUrl={profilePictureUrl}
        isLoading={isLoadingProfilePicture}
        size="small"
      />

      <Box>
        <Text semibold variant="body2">
          {workerName}
        </Text>

        <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
          {formatDistanceToNow(createdAt)} ago
        </Text>
      </Box>
    </Stack>
  );
}
